module.exports = __webpack_public_path__ + "static/media/113.d4dabf6a.jpg";